import { cloneDeep } from 'lodash/lang';

import { serializePhoneNumber } from '../../../../../../../../services/geo/e-164';
import { PAYMENT_TYPE_PHYSICAL } from '../../../../constants';
import { convertDobToDate } from '../AddOrEditPatientInfoModalService';

export default function prepareUpdatePatientInfo(info, originalPID) {
  const clonedPatientInfo = cloneDeep(info);
  const { phonesInfo, paymentType, cardId, guardianPhone, ...restPatientInfo } = clonedPatientInfo;
  const { primary, alternative, ...restPhonesInfo } = phonesInfo;
  const primaryPhoneNumber = serializePhoneNumber(phonesInfo.primary.nationalNumber);
  const alternativePhoneNumber = serializePhoneNumber(phonesInfo.alternative.nationalNumber);
  const guardianPhoneNumber = serializePhoneNumber(guardianPhone.nationalNumber);

  return {
    ...restPatientInfo,
    cardId,
    dob: convertDobToDate(info.dob),
    guardianDob: convertDobToDate(info.guardianDob),
    guardianPhone: guardianPhoneNumber || null,
    guardianPhoneCode: guardianPhoneNumber ? guardianPhone.countryId : null,
    paymentType: cardId && !paymentType ? PAYMENT_TYPE_PHYSICAL : paymentType,
    changedCardId: originalPID !== cardId && Boolean(cardId),
    phonesInfo: {
      ...restPhonesInfo,
      primary: primaryPhoneNumber,
      primaryPhoneCode: primaryPhoneNumber && phonesInfo.primary.countryId,
      primaryPhoneType: phonesInfo.primary.phoneType,

      alternative: alternativePhoneNumber,
      alternativePhoneCode: alternativePhoneNumber && phonesInfo.alternative.countryId,
      alternativePhoneType: phonesInfo.alternative.phoneType
    }
  };
}
